import { identity } from 'ramda'
import * as React from 'react'

interface GridTabsArguments {
  selectedTab: string
  setSelectedTab: (tab: string) => void
}

const GridTabsContext = React.createContext<GridTabsArguments>({
  selectedTab: '',
  setSelectedTab: identity,
})

export function useGridTabsContext() {
  const context = React.useContext(GridTabsContext)
  if (!context) {
    throw new Error(
      'Attempted to access tabs context before initializing it, please use GridTabsProvider to initialize the context.',
    )
  }
  return context
}

export function GridTabsProvider({ children }: React.PropsWithChildren) {
  const [selectedTab, setSelectedTab] = React.useState<string>('')

  return <GridTabsContext.Provider value={{ selectedTab, setSelectedTab }}>{children}</GridTabsContext.Provider>
}
